<template>
    <div>
        <!-- <heads></heads> -->
        <div class="wid1200">
            <div class="mart30" v-if="tabListIndex == 0 || tabListIndex == 1">
                <div class="font30 font600 padtb5">{{ detailObj.title }}</div>
                <div>
                    <el-link type="info" @click.native="toNext(index)">
                        成都写字楼出售</el-link>
                    <el-link type="info" @click.native="toList(detailObj.districtCode, 'qy')">
                        >{{ commonfun.returnRegion(detailObj.districtCode) }}写字楼</el-link>
                    <el-link type="info" @click.native="toList(index)">
                        >{{
                            commonfun.returnBussileList(detailObj.business)
                        }}写字楼</el-link>
                    <el-link type="info" @click.native="toList(index)">
                        >{{ detailObj.dictName }}</el-link>
                    <el-link type="info"> >{{ detailObj.dictName }}出售房源</el-link>
                </div>
            </div>
            <el-row class="mart30">
                <el-col :span="12">
                    <div class="swiper-box" style="height: 550px" v-if="dataList.length > 0">
                        <!-- swiper1 -->
                        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
                            <swiper-slide v-for="(item, index) in dataList" :key="index">
                                <!-- <el-image 
                      class="comp-intro-banner img100"
                      :src="item.url" 
                      :preview-src-list="getSrcList(index)">
                </el-image>-->
                                <img class="comp-intro-banner img100" v-if="item.imageType != 4" :src="item.url" alt="item.title" />
                                <video v-else class="comp-intro-banner img100" :src="item.url" controls="controls"></video>
                            </swiper-slide>

                            <div class="swiper-button-next swiper-button-white" slot="button-next"></div>
                            <div class="swiper-button-prev swiper-button-white" slot="button-prev"></div>
                        </swiper>
                        <!-- swiper2 Thumbs -->
                        <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
                            <swiper-slide v-for="(item, index) in dataList" :key="index" class="slide-1">
                                <img class="swiperSmallImg" v-if="item.imageType != 4" :src="item.url" alt="item.title" />
                                <img class="swiperSmallImg" v-else src="http://img.sccshf.com/video.png" />
                            </swiper-slide>
                        </swiper>
                    </div>
                </el-col>
                <el-col :span="11" :offset="1" class="">
                    <div>
                        <span class="colred font40 font600">{{ detailObj.prices }}</span>
                        <span class="font14 col333">万</span>
                        <span class="font14 col333 padl100">参考单价：{{ detailObj.price }}元/m²</span>
                    </div>
                    <el-row class="padtb45 textcenter">
                        <el-col :span="6">
                            <p class="font20 font600 col333 line30">
                                {{ detailObj.area }}平米
                            </p>
                            <p class="font12 col999">建筑面积</p>
                        </el-col>
                        <el-col :span="6">
                            <p class="font20 font600 col333 line30">
                                {{ detailObj.renovation }}
                            </p>
                            <p class="font12 col999">装修情况</p>
                        </el-col>
                        <el-col :span="12">
                            <p class="font20 font600 col333 line30">
                                约{{ detailObj.apartmentG }}工位
                            </p>
                            <p class="font12 col999">可容工位</p>
                        </el-col>
                    </el-row>
                    <div class="line40">
                        <span class="font14 font600 col333"><i class="el-icon-office-building"></i>楼盘名称</span>
                        <router-link :to="{
                            name: 'builsDetail',
                            query: { houseid: detailObj.dictId },
                        }">
                            <span class="font14 col999 padl40 titleHouer">{{
                                detailObj.dictName
                            }}</span>
                        </router-link>
                    </div>
                    <div class="line40">
                        <span class="font14 font600 col333"><i class="el-icon-school"></i>所在楼层</span>
                        <span class="font14 col999 padl40">{{ detailObj.floor }}</span>
                    </div>
                    <div class="line40">
                        <span class="font14 font600 col333"><i class="el-icon-map-location"></i>所在地址</span>
                        <span class="font14 col999 padl40">{{ commonfun.returnRegion(detailObj.districtCode) }}-{{
                            commonfun.returnBussileList(detailObj.business)
                        }}{{ detailObj.address }}</span>
                    </div>
                    <div class="line40">
                        <span class="font14 font600 col333"><i class="el-icon-s-opportunity"></i>房源编号</span>
                        <span class="font14 col999 padl40">{{ "FY-" + detailObj.id }}</span>
                    </div>
                    <div class="callbox">
                        <el-row class>
                            <el-col :span="4">
                                <img :src="detailObj.wxPhoto" class="icon64" alt />
                            </el-col>
                            <el-col :span="10" class>
                                <div class="line30">
                                    <span class="font12 col999">房源顾问</span>
                                    <span class="font16 col333 font600">{{
                                        detailObj.userName
                                    }}</span>
                                </div>
                                <div class="font14 col333">好评经纪人，熟悉本房特色</div>
                            </el-col>
                            <el-col :span="10">
                                <p class="font20 colred font600 italic line80">
                                    {{ detailObj.mobile }}
                                </p>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </el-row>

            <el-row :class="[
                titleFixes == true ? 'isFixed mt0' : '',
                'width100 mart20 font16 col333 bgf5 line30 padtb5 textcenter',
            ]" style="background: #f5f5f5">
                <el-col :span="20">
                    <el-col :span="3" v-for="(item1, index) in tabList" :key="index" @click.native="changeTab(index)">
                        <span :class="tabListIndex == index ? 'borb' : ''">{{
                            item1.name
                        }}</span>
                    </el-col>
                </el-col>
            </el-row>
            <div class="mart50">
                <el-row>
                    <el-col :span="17">
                        <div v-if="tabListIndex == 0">
                            <p class="colred font24 font600">房源基本信息</p>
                            <div class="col333 font20 font600 mart30">基本信息</div>
                            <el-row class="mart20">
                                <el-col :span="12">
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源格局:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                办公室({{ detailObj.apartmentB }}) 会议室({{ detailObj.apartmentH }}) 工位({{ detailObj.apartmentG }})
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <!-- <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源朝向:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel( "dictDirection", detailObj.direction )}}
                                            </span>
                                        </el-col>
                                    </el-row> -->
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">写字楼等级:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">{{ detailObj.olevel }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源状态:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictSituation", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">付款方式:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictTenanPay", detailObj.payType) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <!-- <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">通上下水:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{  commonfun.getDictLabel( "houseWater", detailObj.situation ) }}
                                            </span>
                                        </el-col>
                                    </el-row> -->
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">空调:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("houseHeating", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">能否注册:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">能</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">物业费:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent"> {{ detailObj.propertyPrice }}元/㎡</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">入驻时间:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                <span class="msgcontent">
                                                    {{ commonfun.getDictLabel("houseInTime", detailObj.inTime) || '随时' }}
                                                </span>

                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                        <!-- <div v-if="tabListIndex == 0">
                            <p class="colred font24 font600">房源基本信息</p>
                            <div class="col333 font20 font600 mart30">基本信息</div>
                            <el-row class="mart20">
                                <el-col :span="12">
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源格局:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                办公室({{ detailObj.apartmentB }}) 会议室({{ detailObj.apartmentH }}) 工位({{ detailObj.apartmentG }})
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源朝向:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictDirection", detailObj.direction) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">写字楼等级:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">{{ detailObj.olevel }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">房源状态:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictSituation", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">付款方式:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictOwnerBuy", detailObj.payType) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">通上下水:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("houseWater", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">空调:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("houseHeating", detailObj.situation) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">能否注册:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">能</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">物业费:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent"> {{ detailObj.propertyPrice }}</span>
                                        </el-col>
                                    </el-row>
                                    <el-row class="basicinfo">
                                        <el-col :span="8">
                                            <span class="msglable">看房方式:</span>
                                        </el-col>
                                        <el-col :span="16">
                                            <span class="msgcontent">
                                                {{ commonfun.getDictLabel("dictLookMode", detailObj.lookMode) }}
                                            </span>
                                        </el-col>
                                    </el-row>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 1">
                            <div class="col333 font20 font600 mart30">配套设施</div>
                        </div> -->
                        <!-- <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 2">
                            <el-row>
                                <el-col :span="12">
                                    <p class="colred font24 font600">经纪人带看反馈</p>
                                </el-col>
                                <el-col :span="12" class="textright">
                                    <span class="font12 col333">带看最多</span>
                                    <span class="font12 col999">最新</span>
                                </el-col>
                            </el-row>
                            <div class="dklist mart30">
                                <el-row v-for="(item, index) in followArr" :key="index" class="padtb20">
                                    <el-col :span="3">
                                        <img :src="item.headUrl" class="icon56" alt />
                                    </el-col>
                                    <el-col :span="21">
                                        <el-row>
                                            <el-col :span="12" class="font16 col333">{{
                        item.userName
                      }}</el-col>
                                           
                                        </el-row>
                                        <div class="font14 col666 padtb5 line24 mart5">
                                            {{ item.content }}
                                        </div>
                                        <el-row>
                                            <el-col :span="12" class="font12 col666">{{
                        item.createDate
                      }}</el-col>
                                            <el-col :span="12" class="font14 colred textright">
                                              
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                <div class="textcenter col999 font12" v-if="followNum != ''">
                                    {{ followNum }}
                                </div>
                            </div>
                            <div class="lookbtn" v-if="followNum == ''" @click="getFollow('2')">
                                查看更多带看反馈
                            </div>
                        </div> -->

                        <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 2">
                            <p class="colred font24 font600">房源图片</p>
                            <el-row class="mart30">
                                <el-col :span="12" v-for="(item, index) in dataList" :key="index" v-show="index < num">
                                    <div class="houseImg">
                                        <el-image v-if="item.imageType != 4" class="detailimg" style="width: 100px; height: 100px" :src="item.url" :preview-src-list="getSrcList(index)">
                                        </el-image>
                                        <video class="detailimg" v-else :src="item.url" controls="controls"></video>
                                        <!-- <img :src="item.url" alt /> -->
                                    </div>
                                </el-col>
                            </el-row>
                            <div style="text-align:center" v-if="dataList.length > 4">
                                <el-button @click="showMore" type="danger" plain>{{ txt }}</el-button>
                            </div>

                        </div>
                    </el-col>
                    <el-col :span="6" :offset="1" class="searchBar" id="searchBar">
                        <div :class="[
                            searchBarFixed == true ? 'isFixed mt40' : '',
                            'border1 pad10',
                        ]">
                            <!-- <p class="font18 col333 font600">果壳里的城+中高楼层...</p>
              <el-row class="borderb padtb15 mart5">
                <el-col :span="6" class="line30">
                  <span class="font20 colred">85</span>
                  <span class="font14">万</span>
                </el-col>
                <el-col :span="18" class="textright font12 line40">参考单价：15406.9元/</el-col>
              </el-row>-->
                            <div class="font16 col333 line30 font600">咨询顾问</div>
                            <div v-for="(item, index) in AgentArr" :key="index" class="padtb10">
                                <div class="disinline headurl">
                                    <img :src="item.headUrl" class="icon36" alt />
                                </div>
                                <div class="disinline">
                                    <div class="font14 col000 font600">
                                        {{ item.userName }}
                                        <span class="font12 col999">房源顾问</span>
                                    </div>
                                    <div class="font12 padtb5 col666">好评经纪人</div>
                                    <div class="font12 colred">咨询热线：{{ item.mobile }}</div>
                                </div>
                            </div>
                            <div>
                                <entrust :paramsid="id" type="1"></entrust>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div class="mart50 " ref="mapcontent" v-if="tabListIndex == 0 || tabListIndex == 3">
                    <p class="colred font24 font600">周边配套</p>
                    <bdmap class="mart30" :latitudeVal="detailObj.latitude" :dictName="detailObj.dictName"></bdmap>
                </div>
                <div class="mart50" v-if="tabListIndex == 0 || tabListIndex == 4">
                    <p class="colred font24 font600">为你推荐优质房源</p>
                    <el-row class="mart30">
                        <el-col :span="6" v-for="(item, index) in recommendList" :key="index">
                            <div class="wid95" @click="relond">
                                <el-image v-if="item.imageUrl" :src="item.imageUrl" alt />
                                <el-image v-else src="http://img.sccshf.com/defaultimage1.png" />
                                <div class="font14 col333">{{ item.dictName }}</div>
                                <el-row class="line30">
                                    <el-col :span="14" class="font12 col999">{{ commonfun.returnRegion(item.districtCode) }}-{{
                                        commonfun.returnBussileList(item.business)
                                    }}</el-col>
                                    <el-col :span="10" class="textright">
                                        <span class="font16 colred font600">{{ item.prices }}</span>
                                        <span class="font12 colred">万</span>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import bdmap from "../../components/baiduMapView";
import "swiper/dist/css/swiper.css";
import findMap from "../../components/findHouseForMap";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import entrust from "../../components/entrust";
export default {
    name: "officemmDetail",
    data() {
        return {
            id: "",
            type: "",
            telFindHouse: "", //委托
            // id:'',
            detailObj: {},
            dataList: [],
            BigImg: [],
            swiperOptionTop: {
                spaceBetween: 10,
                loop: true,
                loopedSlides: 5, //looped slides should be the same
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
            },
            swiperOptionThumbs: {
                spaceBetween: 10,
                slidesPerView: 4,
                touchRatio: 0.2,
                loop: true,
                loopedSlides: 5, //looped slides should be the same
                slideToClickedSlide: true,
            },
            tabList: [
                { name: "基本信息", id: "0" },
                // { name: "配套设施", id: "1" },

                { name: "房源图片", id: "2" },
                { name: "周边配套", id: "3" },
                { name: "优房推荐", id: "4" },
            ],
            tabListIndex: 0,
            followparmas: {
                page: 1,
                limit: 3,
                orderField: "",
                order: "",
                houseId: "",
            },
            recommend: {
                page: 1,
                limit: 4,
                orderField: "",
                tenant_code: this.$store.state.tenantCode, //城市编码
                order: "",
                dictId: "",
            },
            recommendList: [],
            followArr: [],
            AgentArr: [],
            followNum: "暂无数据",
            searchBarFixed: false,
            titleFixes: false,
            isShow: true,
            txt: "显示全部",
            num: 4,
        };
    },
    components: {
        bdmap,
        swiper,
        swiperSlide,
        findMap,
        entrust,
    },
    created() {
        //  console.log(this.$route.query.houseid)
        this.id = this.$route.query.houseid;
        this.followparmas.houseId = this.id;

        this.getDtail();
        this.getpageImage();
        this.getFollow("1");
        this.getAgent();
    },
    mounted() {
        this.$emit("getMenuId", 2);
        // console.log(this.$store.state.allDictType)
        // this.$nextTick(() => {
        //   const swiperTop = this.$refs.swiperTop.swiper;
        //   const swiperThumbs = this.$refs.swiperThumbs.swiper;
        //   swiperTop.controller.control = swiperThumbs;
        //   swiperThumbs.controller.control = swiperTop;
        // });
        window.addEventListener("scroll", this.handleScroll);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    },
    watch: {},
    methods: {
        relond(id) {
            let routeUrl = this.$router.resolve({
                path: "/officemmDetail",
                query: {
                    houseid: id,
                },
            });
            window.open(routeUrl.href, "_blank");
        },
        handleScroll() {
            var scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;

            if (scrollTop > 500) {
                this.searchBarFixed = true;
                this.titleFixes = true;
            } else {
                this.searchBarFixed = false;
                this.titleFixes = false;
                this.tabListIndex = 0;
            }
            if (this.tabListIndex == 0 || this.tabListIndex == 3) {
                var h = this.$refs.mapcontent.offsetTop;
                if (scrollTop > h && scrollTop < h + 300) {
                    this.searchBarFixed = false;
                }
            }
        },
        changeTab(id) {
            this.tabListIndex = id;
        },
        // 页面详情
        getDtail() {
            this.$get(this.$api.officeBuild.getSellOffice, { id: this.id })
                .then((res) => {
                    console.log("页面详情", res);
                    if (res.code == 0) {
                        this.detailObj = res.data;
                        this.recommend.dictId = res.data.dictId;
                        this.recommendLeaseList();
                    }
                })
                .catch((err) => {
                    console.log("页面详情err", err);
                });
        },
        // 页面图片详情
        getpageImage() {
            this.$get(this.$api.officeBuild.pageImage, { id: this.id })
                .then((res) => {
                    console.log("页面图片详情", res);
                    if (res.code == 0) {
                        if (res.data.length > 0) {
                            this.dataList = res.data;
                        } else {
                            this.dataList.push({
                                url: "../../../static/img/wu.png",
                            });
                        }
                        this.$nextTick(() => {
                            const swiperTop = this.$refs.swiperTop.swiper;
                            const swiperThumbs = this.$refs.swiperThumbs.swiper;
                            swiperTop.controller.control = swiperThumbs;
                            swiperThumbs.controller.control = swiperTop;
                        });
                        this.dataList.forEach((item) => {
                            this.BigImg.push(item.url);
                        });
                    }
                })
                .catch((err) => {
                    console.log("页面详情err", err);
                });
        },
        getSrcList(index) {
            return this.BigImg.slice(index).concat(this.BigImg.slice(0, index));
        },
        // 房源跟进
        getFollow(type) {
            if (type == 1) {
                this.followparmas.page = 1;
            } else {
                this.followparmas.page += 1;
            }
            this.$get(this.$api.officeBuild.pageFollow, this.followparmas)
                .then((res) => {
                    console.log("房源跟进", res);
                    if (res.code == 0) {
                        if (res.data.list.length > 0) {
                            this.followNum = "";
                            this.followArr = this.followArr.concat(
                                this.followArr,
                                res.data.list
                            );
                        } else {
                            this.followNum = "已经到底啦......";
                        }
                    }
                })
                .catch((err) => {
                    console.log("房源跟进err", err);
                });
        },
        // 经纪人
        getAgent() {
            this.$get(this.$api.officeBuild.getAgent, { houseId: this.id })
                .then((res) => {
                    console.log("经纪人", res);
                    if (res.code == 0) {
                        this.AgentArr = res.data;
                    }
                })
                .catch((err) => {
                    console.log("经纪人err", err);
                });
        },
        recommendLeaseList() {
            this.$get(this.$api.officeBuild.recommendSellList, this.recommend)
                .then((res) => {
                    console.log("推荐", res);
                    if (res.code == 0) {
                        this.recommendList = res.data.list;
                    }
                })
                .catch((err) => {
                    console.log("推荐err", err);
                });
        },
        showMore() {
            this.isShow = !this.isShow;
            this.num = this.isShow ? 4 : this.dataList.length;
            this.txt = this.isShow ? "显示全部" : "收起";
        },
    },
};
</script>

<style  lang="scss">
@import "office.scss";
</style>



// WEBPACK FOOTER //
// src/pages/office/officemmdetail.vue